export interface NewsPostBlockRequestDto {
  blockReason: string;
}
